import React, {Component} from "react";
import CancelledOrdersTable from "./CancelledOrdersTable/CancelledOrdersTable";
import "./CancelledOrders.css";

class CancelledOrders extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="all-order-content page-padding-responsive">
                <div className="all-order-div admin-inquiry-div">
                    <CancelledOrdersTable/>
                </div>
            </div>
        )
    }
}

export default CancelledOrders;



// WEBPACK FOOTER //
// ./src/components/Admin/Sales/CancelledOrder/CancelledOrders.js